import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        userInfo: {
        },
        isLogin: false,
        iosImageSource: '',
        isLoading: false,
        categories:{},
        swiperList:[]
    },
    mutations: {
        saveUserInfo(state, data) {
            // let data = Object.assign({}, state.userInfo, info);
            state.userInfo = data;
            console.log('仓库數據',state.userInfo);
        },
        updateHeadImg (state,avatar) {
            state.userInfo.avatar = avatar;
        },
        isLogin(state) {
            state.isLogin = true;
        },
        setIOSImageSource(state, source) {
            state.iosImageSource = source;
        },
        showLoading (state) {
            state.isLoading = true;
        },
        hideLoading (state) {
            state.isLoading = false;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },
        setSwiperArray(state, swiperList) {
            state.swiperList = swiperList;
            console.log('swiper图片',swiperList);
        }
    },
    actions: {},
    modules: {}
})